const CountryCode = {
  "+503": "SV",
  "+505": "NI",
};

module.exports = {
  CountryCode,
};
